@if(vm) {
  <!-- Show if there are error on the API -->
  @if (vm?.error && !vm?.unverifiedOrUnconfirmed) {
    <bp-try-again-error
      [title]="'limit_orders_widget_error' | translate"
      [message]="'assets_loading_error_message' | translate"
      [tryAgainMessage]="'try_again' | translate"
    (onRetry)="onRefetchLimitOrders()"></bp-try-again-error>
  } @else {
    @if (vm?.data.length > 0) {
      @for (order of vm?.data; track order) {
        <order-adp-widget [order]="order" (onOpenDetails)="openDetails($event)"></order-adp-widget>
      }
      @if (vm?.data.length > 0) {
        <div class="justify-center">
          <button class="limit-order-widget-button btn btn-primary" (click)="goToLimitOrders()"
            >{{ "check_all_orders" | translate }}
          </button>
        </div>
      }
    } @else {
      <div class="empty-state-container">
        <order-action-ui
          [orderAbTestEnabled]="vm?.totalOrdersEnabled"
          [orderType]="vm?.orderType"
          [showCheckOrders]="showCheckOrders"
          [pillSelected]="selectedPill"
          [isNewSellVisible]="isNewSellVisible"
          (onGoToLimitOrders)="goToLimitOrders()"
        (onCreateOrder)="createOrder($event)"></order-action-ui>
      </div>
    }
    <!-- Show if there are no active open orders -->
  }
} @else {
  <loading-spinner class="green loader-big"></loading-spinner>
}
